/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ClaimRequest
 */
export interface ClaimRequest {
  /**
   *
   * @type {boolean}
   * @memberof ClaimRequest
   */
  claimPersonal?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ClaimRequest
   */
  claimTeam?: boolean
}

export function ClaimRequestFromJSON(json: any): ClaimRequest {
  return ClaimRequestFromJSONTyped(json, false)
}

export function ClaimRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    claimPersonal: !exists(json, 'claimPersonal') ? undefined : json['claimPersonal'],
    claimTeam: !exists(json, 'claimTeam') ? undefined : json['claimTeam'],
  }
}

export function ClaimRequestToJSON(value?: ClaimRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    claimPersonal: value.claimPersonal,
    claimTeam: value.claimTeam,
  }
}
